import React, { Component } from "react";
import { Sendpin } from "../../Model/Users";
import { withRouter, VirsionCheck } from "../../Helpers/Common";
import "./Forgotpassword.css";
import Emailormobileenter from './Emailormobileenter';
import Enterpincode from './Enterpincode';
import Passwordreset from './Passwordreset';
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import BarLoader from "react-spinners/BarLoader";
import { Metadata } from "../Metadata/Metadata";

class Forgotpassword extends Component {
  constructor(props) {

    super(props);
    this.state = {
      fields: { fld_mobile: "", country_code: "+91", fld_email: "", fld_password: "" },
      errors: { isValidEmailerror: false, isValidMobileerror: false },
      msg: { alreadyRegiter: false, validpasswordMsg: false, passwordsent: false },
      enableEmail: false,
      enablePass: false,
      isValidEmail: false,
      isValidPassword: false,
      isValidMobile: false,
      isVeried: false,
      show: true,
      hide: false,
      VirsionCheckData: "",
      VirsionCheckDataloaded: false
    };

    this.handleChange = this.handleChange.bind(this);

  }

  /*-----Virsion Check -------*/

  componentDidMount() {
    VirsionCheck().then((vcheckres) => {
      this.setState({
        VirsionCheckData: vcheckres,
        VirsionCheckDataloaded: true,
      });
    });
  }

  /*----Show Reset Password Page ------------*/
  showresetpasswordview() {

    this.setState({
      isVeried: true,
      hide: false,
      show: false
    })
  }
  /*------------ Send Pin -----------------*/
  async checkuser() {

    var EmailorMobile = this.state.fields;

    await Sendpin(EmailorMobile).then((data) => {

      var CheckuserData = JSON.parse(data.data);
      if (CheckuserData.success == false) {

        var errorState = this.state.errors;
        if (EmailorMobile.fld_email) {
          errorState['isValidEmailerror'] = true;
        } else if (EmailorMobile.fld_mobile) {
          errorState['isValidMobileerror'] = true;
        }
        var AlreadyExistMsg = this.state.msg;
        AlreadyExistMsg['alreadyRegiter'] = CheckuserData.message;
        this.setState({ errorState, AlreadyExistMsg });

      } else {
        //Show Error Email Already Register
        var AlreadyExistMsg = this.state.msg;
        AlreadyExistMsg['passwordsent'] = CheckuserData.message;
        this.setState({ errorState, AlreadyExistMsg });
        this.setState({
          show: false,
          hide: true
        })

      }
    });
  }

  /*------ Change State on input ------*/
  handleChange(e) {

    const fields = this.state.fields;
    var Valuespost = e.target.name;

    if (e.target.name == "fld_email") {

      const isValid = this.state.isValid;
      const emailRegex = /\S+@\S+\.\S+/;

      if (emailRegex.test(e.target.value) && /\s/.test(e.target.value) == false) {
        //Set State For Valid email
        this.setState({
          isValidEmail: true,
        });
        //Already Register Error Removed
        var errorState = this.state.errors;
        errorState['isValidEmailerror'] = false;
        this.setState({ errorState });

      } else {
        this.setState({
          isValidEmail: false,
        });
      }
    } else if (e.target.name == "fld_password") {
      const isValidPassword = this.state.isValidPassword;
      if (e.target.value.length >= 8) {
        var validPasswordMsg = this.state.msg;
        validPasswordMsg['validpasswordMsg'] = true;
        this.setState({
          isShow: true,
          isValidPassword: true,
          errorState,
          validPasswordMsg
        });
      } else {
        var validPasswordMsg = this.state.msg;
        validPasswordMsg['validpasswordMsg'] = false;
        this.setState({
          isValidPassword: false,
          validPasswordMsg
        });
      }
    } else if (e.target.name == "fld_mobile" && /\s/.test(e.target.value) == false) {
      const isValidMobile = this.state.isValidMobile;
      var errorState = this.state.errors;
      errorState['isValidMobileerror'] = false;
      this.setState({ errorState });

      if (e.target.value.length >= 6 && e.target.value.length <= 15 && !isNaN(e.target.value)) {
        this.setState({
          isValidMobile: true,
        });
      } else {
        this.setState({
          isValidMobile: false,
        });
      }
    }

    fields[e.target.name] = e.target.value;
    this.setState({
      fields,
    });
  }


  /*--------Back Button-----------*/
  backbutton() {
    this.props.navigate('/createaccount');
  }

  /*----------Pin Enter back button --------------*/
  CustomeBackButton() {
    this.setState({
      show: true,
      hide: false,
      isVeried: false
    })
  }

  /*---------------ReEnter password Back button--------------------*/

  CustomeBackButton1() {

    this.props.navigate('/createaccount');
  }


  render() {
    if (this.state.VirsionCheckDataloaded == false) {
      //  return <div className="loader"></div>; 
      return <div className="loader"><BarLoader color="#ff000f" /></div>;
    }
    var MetaData = (JSON.parse(
      this.state.VirsionCheckData.data
    ).data).page.forgot_password_page;
    return (
      <>
        {/* <Helmet>
          <title>{MetaData.title}</title>
          <meta name="description" content={MetaData.description} />
          <meta name="keywords" content={MetaData.words} />
          <meta property="og:title" content={MetaData.title} />
        </Helmet> */}
        <Metadata page="FORGOT-PASSWORD" />
        <motion.div
          className=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
        >
          {this.state.show ? <Emailormobileenter data={this} /> : null}
          {this.state.hide ? <Enterpincode data={this} /> : null}
          {this.state.isVeried ? <Passwordreset data={this} /> : null}

        </motion.div>
      </>

    );
  }
}

export default withRouter(Forgotpassword);
